<div class="px-15">
    <section id="overall-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Nurse Dashboard</div>
                </div>
                <div class="subtitle">
                    Real-time clinical activities and patient care overview.
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                
                <div class="card appointment-card" (click)="navigateToVitals()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>thermostat</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Pending Observation Request</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Pending service requests for vitals and observations.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (vitalsPending$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">arrow_forward</mat-icon> Action required
                        </div>
                    </div>
                </div>

                <div class="card appointment-card" (click)="navigateToAdmittedPatients()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>hotel</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Occupied Beds</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Current number of occupied beds.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (bedOccupancy$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility</mat-icon> Current inpatients
                        </div>
                    </div>
                </div>

                <div class="card appointment-card" (click)="navigateToMedicationRequests()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>medication</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Medication Tasks</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Pending medication tasks awaiting administration.">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">{{ (pendingMedTasks$ | async) || 0 }}</div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2 justify-content-start">
                            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">timer</mat-icon> Awaiting administration
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <section id="next-dashboard-tasks" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Next 3 Tasks</div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-20">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                @for(task of (nextTasks$ | async) || []; track task.taskId) {
                <div class="card appointment-card" (click)="navigateToTasks()">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="rounded-icon-wrapper"><mat-icon>task_alt</mat-icon></div>
                            <div>
                                <div class="top-text">{{ task.title }}</div>
                                @if(task.patientReference){
                                <div class="subtitle-text-color-2" [appReferenceDisplay]="task.patientReference" [instantFetchAndReplace]="true">
                                    {{ task.patientReference }}
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="card-bottom g-just-flex gap-8 subtitle-text-color-2 justify-content-start">
                        <mat-icon>schedule</mat-icon>
                        <span>{{ task.start | date:'short' }}</span>
                    </div>
                </div>
                } @empty {
                <div class="subtitle-text-color-2">No open tasks.</div>
                }
            </div>
        </div>
    </section>

    <section id="nurse-quick-actions" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15">Quick Actions</div>
                </div>
            </div>

            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class="rounded-icon-wrapper prev-btn">
                    <mat-icon>chevron_left</mat-icon>
                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="action-button" (click)="navigateToVitals()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>thermostat</mat-icon>
                    </div>
                    <span>Capture Vitals</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToAdmittedPatients()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>hotel</mat-icon>
                    </div>
                    <span>In-Patient List</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="navigateToTasks()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>task_alt</mat-icon>
                    </div>
                    <span>Duty Tasks</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </div>
        </div>
    </section>

    <section id="appointments-summaries" class="scrolld-parent">
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">Patients for Today</div>
            </div>
        </div>

        <div class="section-wrapper pt-20">
              <app-upcoming-activities></app-upcoming-activities>
        </div>
    </section>
</div>
